import { ref, watch, onMounted } from 'vue';
import CloseIcon from "src/components/icons/close/Close.vue";

export default {
    components: {
        CloseIcon
    },
    props: {
        isSideBarOpen: {
            type: Boolean,
            default: false // Default value for isSideBarOpen is false
        }
    },
    setup(props, { emit }) {
        const isPanelOpen = ref(false); // Represents the state of the panel, initially set to false
        const root = document.getElementById('app');

        const closeSidebarPanel = () => {
            isPanelOpen.value = false; // Set isPanelOpen to false when closing the sidebar panel
            emit('toggleSideBar'); // Emit an event to toggle the sidebar
        };

        // Watch for changes in isSideBarOpen prop and update isPanelOpen accordingly
        watch(() => props.isSideBarOpen, (newVal) => {
            isPanelOpen.value = newVal;
            if (newVal) root.style.overflow = 'hidden'; // Prevent scrolling when sidebar is open
            else root.style.overflow = 'unset'; // Allow scrolling when sidebar is closed

        });

        // On component mount, set isPanelOpen to the value of isSideBarOpen prop
        onMounted(() => {
            isPanelOpen.value = props.isSideBarOpen;
        });

        return {
            isPanelOpen,
            closeSidebarPanel
        };
    }
}